import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({ providedIn: 'root' })
export class IndexedDbService {
    private dbPromise: Promise<IDBPDatabase>;

    constructor() {
        this.dbPromise = openDB('LegalAdDB', 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('forms')) {
                    db.createObjectStore('forms');
                }
                if (!db.objectStoreNames.contains('outsideLegals')) {
                    db.createObjectStore('outsideLegals');
                }
            }
        });
    }

    async setItem(store: string, key: string, value: any) {
        const db = await this.dbPromise;
        await db.put(store, value, key);
    }

    async getItem(store: string, key: string) {
        const db = await this.dbPromise;
        return await db.get(store, key);
    }

    async removeItem(store: string, key: string) {
        const db = await this.dbPromise;
        await db.delete(store, key);
    }
}